import { createQueryKeys } from '@lukemorales/query-key-factory';

export const dldMarket = createQueryKeys('dldMarket', {
  offplanIndex: null,
  topSelling: null,
});
